mutation ArchiveUser($id: ID!, $markEmployeeLeft: Boolean, $leftOn: ISO8601Date) {
  archiveUser(
    input: { id: $id, markEmployeeLeft: $markEmployeeLeft, leftOn: $leftOn }
  ) {
    success
  }
}
